import { useParams } from 'react-router-dom';
import PublicMatchViewPage from '../../match/pages/PublicMatchViewPage';

const GaliPublicMatchPage = () => {
  const { publicToken } = useParams();
  return <PublicMatchViewPage tournamentId="gali" matchId={publicToken} />;
};

export default GaliPublicMatchPage;
